import React from 'react';

import { Box, Tooltip } from '@mui/material';
import { InfoIcon } from 'app/shared/componentsRestyled/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { DESCRIPTION_TOOLTIP_POPPER_PROPS } from './DescriptionTooltip.constants';
import { descriptionIconStyles } from './DescriptionTooltip.styles';

const DescriptionTooltip = ({ description }) => (
  <Tooltip arrow PopperProps={DESCRIPTION_TOOLTIP_POPPER_PROPS} placement="top" title={description}>
    <Box component="span" sx={descriptionIconStyles} tabIndex={0}>
      <InfoIcon size={IconSize[16]} />
    </Box>
  </Tooltip>
);

DescriptionTooltip.propTypes = {
  description: PropTypes.string.isRequired,
};

export default DescriptionTooltip;
